import styled from 'styled-components'

export const InputDiv = styled.div`
  height: fit-content;
  position: relative;
`

export const Label = styled.label`
  font-size: 14px;
  font-weight: 700;
  display: block;
  margin-bottom: 0.5rem;
`

export const Input = styled.input`
  width: 100%;
  height: 40px;
  background-color: #EBEBEB;
  border: 0;
  border-radius: 2rem;
  padding: 1rem;
  outline: none;
`

export const SearchOptions = styled.ul`
  position: absolute;
  list-style: none;
  z-index: 1;
  width: 100%;
  top: 4.5rem;
  border-radius: 1rem;
  border: 1px solid #EBEBEB;
  overflow-x: hidden;
  max-height: 10rem;
  overflow-y: auto;
  
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #c0c0c0;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #ffffff;
    border-radius: 10px;
    border: 2px solid #c0c0c0;
  }
`

export const Option = styled.li<{isSelected?:boolean}>`
  cursor: pointer;
  padding: .8rem 1rem;
  background-color: ${props => props.isSelected ? '#F4F4F4' : '#FFF'};
  border-bottom: 1px solid #EBEBEB;
  user-select: none;
  
  &:hover {
    background-color: #F4F4F4;
  }
`